import { render } from "./presentation.vue?vue&type=template&id=1b4b7f48"
import script from "./presentation.vue?vue&type=script&lang=js"
export * from "./presentation.vue?vue&type=script&lang=js"

import "./presentation.vue?vue&type=style&index=0&id=1b4b7f48&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__